<template>
    <register-provider :default-email="defaultEmail" :user-type="userType">
        <div
            slot-scope="{ error, email, password, register, posting, setError, code, passwordIsVisible, passwordInputType, togglePassword, passwordStrength, registerPreflight, termsAccepted, optOut, optIn }"
            class="text-left"
        >
            <div v-if="header" class="mb-4 text-center text-xl font-bold">
                {{ header }}
            </div>

            <span class="block text-sm text-center dark:text-slate-200">
                {{ _('register_form_v3.sso_appls_headline') }}
            </span>

            <div
                class="grid gap-x-2 lg:gap-x-4 mt-2"
                v-bind:class="{'grid-cols-2': isSv, 'grid-cols-1': !isSv}"
                @click.stop="registerPreflight"
            >
                <div class="">

                    <apple-button
                        @error="setError"
                    >
                        <div slot-scope="{ startLoginProcess, working }">
                            <button
                                @click.prevent="() => {registerPreflight() ? startLoginProcess() : null}"
                                class="h-8 btn-hover-only w-full flex items-center justify-center bg-black rounded-full text-sm"
                            >
                                <div class="flex items-center">
                                    <svg-icon v-show="working" url="fas/spinner" class="fas fa-spin w-4 h-4 cursor-pointer flex items-center text-white"></svg-icon>

                                    <svg-icon v-if="!working" url="fab/apple" class="fab w-4 h-4 cursor-pointer text-white"></svg-icon>
                                </div>
                                <span class="ml-2 text-white">
                                    {{ _('register_form_v3.sso_apps.apple_button') }}
                                </span>
                            </button>
                        </div>
                    </apple-button>

                </div>

                <div v-if="isSv">

                    <freja-button
                        @error="setError"
                    >
                        <div slot-scope="{ startLoginProcess, working }">
                            <button
                                @click.prevent="() => {registerPreflight() ? startLoginProcess() : null}"
                                class="h-8 btn-hover-only w-full flex items-center justify-center bg-freja rounded-full text-sm"
                            >
                                <div class="flex items-center">
                                    <span v-show="working">
                                        <svg-icon url="fas/spinner" class="fas fa-spin w-4 h-4 cursor-pointer flex items-center text-white"></svg-icon>
                                    </span>

                                    <span v-if="!working">
                                        <img src="https://cdn.refunder.se/site/resources/img/logos/freja-white.svg" class="h-3" />
                                    </span>
                                </div>
                            </button>
                        </div>
                    </freja-button>

                </div>
            </div>
            <div class="md:mt-8 mt-4 relative">
                <div class="absolute inset-0 flex items-center w-full">
                    <div class="btn-hover-only w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="px-2 bg-white dark:bg-slate-800 text-gray-500 text-sm rounded-full dark:text-slate-300">
                        {{ _('register_form_v3.continue_with_email') }}
                    </span>
                </div>
            </div>
            <form class="mt-4">
                <p v-if="error" v-text="error" class="mb-4 py-2 px-3 bg-red-500 text-white text-center text-sm rounded"></p>

                <div class="flex-wrap">
                    <div class="w-full">
                        <label for="email" class="block text-sm font-bold leading-6 dark:text-slate-200">
                            {{ _('register_form_v3.form.e-mail_label') }}
                        </label>

                        <input
                            v-bind="email.props"
                            v-on="email.events"
                            type="email"
                            class="standard-input mt-2 block w-full rounded-lg border py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-700 sm:text-sm sm:leading-6 dark:bg-slate-700 dark:hover:bg-slate-600 dark:border-gray-500 dark:text-white"
                            name="register_email"
                            :placeholder="_('register_form_v3.form.e-mail_label')"
                        >
                    </div>
                    <div class="mt-4 w-full">
                        <label for="email" class="block text-sm font-bold leading-6 dark:text-slate-200">
                            {{ _('register_form_v3.form.password_label') }}
                        </label>

                        <div class="relative">
                            <input
                                v-bind="password.props"
                                v-on="password.events"
                                :type="passwordInputType"
                                class="standard-input mt-2 block w-full rounded-lg border py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-700 sm:text-sm sm:leading-6 dark:bg-slate-700 dark:hover:bg-slate-600 dark:border-gray-500 dark:text-white"
                                name="register_password"
                                :placeholder="_('register_form_v3.form.password_label')"
                            >

                            <div @click="togglePassword" class="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                                <svg-icon
                                    v-show="!passwordIsVisible"
                                    url="far/eye"
                                    class="w-4 h-4 cursor-pointer"
                                ></svg-icon>

                                <svg-icon
                                    v-show="passwordIsVisible"
                                    url="far/eye-slash"
                                    class="w-4 h-4 cursor-pointer"
                                ></svg-icon>
                            </div>
                        </div>
                        <div class="flex -mx-1 my-2">
                            <template v-for="(v,i) in 5">
                                <div class="w-1/5 px-1" v-bind:key="i">
                                    <div
                                        class="h-2 rounded-xl transition-colors"
                                        :class="i < passwordStrength.score ? (passwordStrength.score <= 2 ? 'bg-red-400' : (passwordStrength.score <= 4 ? 'bg-orange-400' : 'bg-green-500')) : 'bg-gray-300'"
                                    ></div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div v-if="!hideMgmCode && !showMgmCodeField" class="text-right mt-4 {% if hide_mgm_code %} hidden{% endif %}">
                    <a @click.prevent="showMgmCodeField = true" class="text-primary-700 text-sm cursor-pointer">
                        {{ _('register_form_v3.form.mgm_code_checkbox') }}
                    </a>
                </div>

                <div v-if="mgmCode">
                    <div v-if="showMgmCodeField">
                        <div>
                            <label for="email" class="block text-sm font-bold leading-6 dark:text-slate-200">
                                {{ _('register_form_v3.form.mgm_code_label') }}
                            </label>
                            <div class="mt-1 rounded shadow-sm">
                                <input
                                    v-bind="code.props"
                                    v-on="code.events"
                                    type="text"
                                    class="standard-input mt-2 block w-full rounded-lg border py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-700 sm:text-sm sm:leading-6 dark:bg-slate-700 dark:hover:bg-slate-600 dark:border-gray-500 dark:text-white"
                                    name="register_mgm_code"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4 space-y-2">
                    <!-- Checkbox for mail opt-in -->
                    <div class="flex items-start">
                        <div class="flex items-center">
                            <!-- Zero-width space character, used to align checkbox properly -->
                            &#8203;
                             <input
                                v-on="optIn.campaigns.events"
                                :checked="optIn.campaigns.props.value"
                                id="register-optout-offers"
                                type="checkbox"
                                class="h-4 w-4 rounded transition duration-150 focus:ring-primary-500 text-primary-700 ease-in-out"
                            >
                        </div>
                        <label for="register-optout-offers" class="standard-label checkbox dark:text-slate-200" v-html="_('register_form_v3.form.opt_in.campaigns')"></label>
                    </div>

                    <!-- Checkbox for mail opt-out -->
                    <div class="flex items-start">
                        <div class="flex items-center">
                            <!-- Zero-width space character, used to align checkbox properly -->
                            &#8203;
                            <input
                                v-on="optOut.campaigns.events"
                                :checked="optOut.campaigns.props.value"
                                id="register-optout-non-cashback-offers"
                                type="checkbox"
                                class="h-4 w-4 rounded transition duration-150 ease-in-out focus:ring-primary-500 text-primary-700"
                            >
                        </div>
                        <label for="register-optout-non-cashback-offers" class="standard-label checkbox dark:text-slate-200" v-html="_('register_form_v3.form.opt_out.campaigns')"></label>
                    </div>

                    <!-- Checkbox for terms and conditions -->
                    <div class="flex items-start">
                        <div class="flex items-center">
                            <!-- Zero-width space character, used to align checkbox properly -->
                            &#8203;
                            <input
                                v-bind="termsAccepted.props"
                                v-on="termsAccepted.events"
                                id="register-terms-accepted"
                                type="checkbox"
                                class="h-4 w-4 rounded transition duration-150 ease-in-out focus:ring-primary-500 text-primary-700"
                            >
                        </div>
                        <register-terms-provider>
                            <label
                                for="register-terms-accepted" class="standard-label checkbox dark:text-slate-200"
                                slot-scope="{ beforeTermsText, termsLinkText, betweenTermsAndPrivacyText, privacyLinkText, afterPrivacyText }"
                            >
                                <!-- Keep it tight to avoid whitespace -->
                                {{ beforeTermsText }}<a
                                    href="#"
                                    @click.prevent="showModal('user-terms')"
                                    class="text-primary-700 inline-block"
                                >{{ termsLinkText }}</a>
                                {{ betweenTermsAndPrivacyText }}<a
                                    href="#"
                                    @click.prevent="showModal('privacy-policy')"
                                    class="text-primary-700 inline-block"
                                >{{ privacyLinkText }}</a>{{ afterPrivacyText }}
                            </label>
                        </register-terms-provider>
                    </div>
                </div>

                <button @click.prevent="register" class="mt-8 btn btn-primary w-full">
                    <span v-if="posting">
                        <svg-icon
                            url="fas/spinner"
                            class="inline-block fa-spin mr-2 w-4 h-4"
                        />
                    </span>
                    <span v-else>
                        <template v-if="!cta">
                            {{ _('register_form_v3.form.button') }}
                        </template>
                        <template v-else>
                            {{ cta }}
                        </template>
                    </span>
                </button>

                <div class="text-center mt-4 dark:text-gray-100">
                    {{ _('register.already_member') }}

                    <a
                        :href="getPath('user.login')"
                        class="text-primary-700"
                    >
                        {{ _('register.login') }}
                    </a>

                </div>
            </form>
        </div>
    </register-provider>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {

        template: '#register-form-version-three-template',

        props: {
            defaultEmail: {
                type: String,
                required: false,
            },
            freja: {
                required: false,
                type: Boolean,
                default: true,
            },
            facebook: {
                required: false,
                type: Boolean,
                default: true,
            },
            apple: {
                required: false,
                type: Boolean,
                default: true,
            },
            userType: {
                required: false,
                type: String,
                default: 'user',
            },
            mgmCode: {
                required: false,
                type: Boolean,
                default: true,
            },
            hideMgmCode : {
                required: false,
                type: Boolean,
                default: false,
            },
            header: {
                required: false,
                type: String,
            },
            cta: {
                required: false,
                type: String,
            },
        },

        data() {
            return {
                showMgmCodeField: false
            }
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath', 'isSv'])
        },

        methods: {
            ...mapMutations('modal', ['showModal'])
        }

    }

</script>
